






























































import { Invoice } from '@/types/entity';
import { ApiRequest } from '@/types/request';
import { MedTransGoConstants } from '@/util/constants';
import { DateUtils } from '@/util/dateUtils';
import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/ServiceRequestDetails.scss';
import { ObjectFactory } from '../../config/objectFactory';
import { MemberProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import ChangePaymentModal from './ChangePaymentModal.vue';
import AddPaymentModal from './AddPaymentModal.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
@Component({
    props: {
        fileName: String,
        chargeInvoiceDetails: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        ChangePaymentModal,
        AddPaymentModal,
    },
})
export default class ViewReceiptModal extends Vue {

    private show = true;
    private fileURL: any = '';
    private showPayInvoiceModal = false;
    private paymentCustomer: any = '';
    private customerPaymentId = '';
    private paymentCustomerId: string = '';
    private showChangePaymentForm = false;
    private showAddPaymentForm = false;
    private errorMessage = '';
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();

    private mounted() {
        if (this.$route.query.orignal && this.$route.query.orignal === 'true') {
            this.displayOriginalInvoice(this.$route.params.id);
        } else if (this.$route.params.id) {
            this.getInvoiceReceipt(this.$route.params.id);
        } else if (this.$props.fileName) {
            this.showSubscriptionInvoice(this.$props.fileName);
        }
        if (this.$route.params.id) {
            this.saveInvoiceViewedOn(this.$route.params.id);
        }
    }


    /**
     * @author <Durga.S>
     * @description - Returns pdf file
     * @param req {Request} - Express Request - invoice Id
     * @param res {Response} - Express Response - pdf file
     * @returns patient details
     * @throws InvalidRequestException if invoice id is invalid
     */
   private async getInvoiceReceipt(id: string) {
        const pdfBuffer = await ObjectFactory.getInvoiceService().
        getInvoiceReceipt(this.$store.state.serverUrl, id) as any;
        const file = new Blob([pdfBuffer], {type: 'application/pdf'});
        this.fileURL = URL.createObjectURL(file);
    }

    private async displayOriginalInvoice(id: string) {
        const iHttpService = ObjectFactory.getHttpService();
        const invoiceApiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${id}`,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Invoice>(invoiceApiRequest);
        if (response.success && response.data && response.data.originalPdfResourceId) {
            const fileName: string = response.data.originalPdfResourceId;
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/download/${fileName}`,
                loaderEvent: {
                    show: true,
                },
                responseType: 'arraybuffer',
            };
            const fileBuffer = await iHttpService.get<any>(apiRequest) as any;
            if (fileName.toLowerCase().endsWith('.pdf')) {
                const file = new Blob([fileBuffer], {type: 'application/pdf'});
                this.fileURL = URL.createObjectURL(file);
            }
        }
    }
    private async showSubscriptionInvoice(fileName: string) {
        this.fileURL = '';
        const iHttpService = ObjectFactory.getHttpService();
        if (fileName) {
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/download/${fileName}`,
                loaderEvent: {
                    show: true,
                },
                responseType: 'arraybuffer',
            };
            const fileBuffer = await iHttpService.get<any>(apiRequest) as any;
            if (fileName.toLowerCase().endsWith('.pdf')) {
                const file = new Blob([fileBuffer], {type: 'application/pdf'});
                this.fileURL = URL.createObjectURL(file);
            }
        }
    }

    private async saveInvoiceViewedOn(invoiceId: string) {
        const iHttpService = ObjectFactory.getHttpService();
        const updateRequest = {
            viewedOn: DateUtils.getCurrentUTCTimeInMillis(),
        };
        const invoiceApiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${invoiceId}/saveInvoiceViewedon`,
            data: updateRequest,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        await iHttpService.put<Invoice>(invoiceApiRequest);
    }

    private close() {
        if (this.$route.params.id) {
            this.$router.back();
        } else {
            this.$emit('close');
        }
    }

    private async showPaymentDetails() {
        await this.getPaymentCustomer();
        this.showPayInvoiceModal = true;
    }

    private async getPaymentCustomer() {
        if (!this.customerPaymentId) {
            const memberResponse = await ObjectFactory.getMemberService().
                    getMemberDetails(this.$store.state.serverUrl, this.memberProfile.memberId);
            if (memberResponse.success && memberResponse.data && memberResponse.data.paymentCustomerId) {
                this.customerPaymentId = memberResponse.data.paymentCustomerId;
                this.paymentCustomerId = memberResponse.data.paymentCustomerId;
            } else {
                this.paymentCustomer = '';
                return;
            }
        }
        const response = await ObjectFactory.getPaymentSourceService()
            .getPaymentCustomer(this.$store.state.serverUrl, this.customerPaymentId);
        this.paymentCustomer = response.data;
    }

    private async chargeInvoice() {
        const iHttpService = ObjectFactory.getHttpService();
        const invoiceApiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${this.$props.chargeInvoiceDetails.invoiceId}/charge`,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(invoiceApiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_INVOICE_PAID'),
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.showPayInvoiceModal = false;
            this.close();
        } else {
            this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
        }
    }
}
